import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import StatusMessages from '../../components/StatusMessages';
import BlankState from '../../components/BlankState';
import DataTable from '../../components/DataTable';
import Page from '../../components/Page';
import { TabHolder, Tab } from '../../components/Tabs';

import { getUsers } from '../../utils/apiService';
import { saveUser } from '../../actions/user';

import { fetchFilteredUsers } from '../../actions/user';
import { listInsurers } from '../../actions/insurers';

import SimpleReactValidator from 'simple-react-validator';

class Users extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator();

    this.state = {
      user: {
        postal_address: '',
        first_name: '',
        last_name: '',
        other_names: '',
        username: '',
        user_type: '',
        email: '',
        phone: '',
        employee_number: '',
        is_active: true
      },
      filter: {
        user_role: '',
        insurer: ''
      },
      isRegistering: false,
      modalIsOpen: false,
      users: [],
      users_loading: true,
      active_user: {},
      filteredUsers: []
    };
  }

  componentDidMount() {
    const { listInsurers } = this.props;
    listInsurers();
    getUsers()
      .then(response => {
        this.setState({ users: response.data, users_loading: false });
      })
      .catch(error => {
        this.setState({ users_loading: false });
      });
    this.getFilteredUsers();
  }

  getFilteredUsers() {
    const { fetchFilteredUsers } = this.props;

    fetchFilteredUsers(this.state.filter);
  }

  onChange2 = e => {
    const { name, value } = e.target;

    this.setState(
      {
        filter: {
          ...this.state.filter,
          [name]: value
        }
      },
      () => {
        console.log(this.state.filter);
        this.getFilteredUsers();
      }
    );
  };

  onChange1 = e => {
    const { name, value } = e.target;
    const { userList } = this.state;
    let x = [];
    this.setState(
      {
        filter: {
          ...this.state.filter,
          [name]: value
        }
      },
      () => {
        let filtered = userList.filter(users => {
          if (
            this.state.filter.insurer !== '' &&
            this.state.filter.user_role === ''
          ) {
            return users.user_profile.company === this.state.filter.insurer;
          }
          if (
            this.state.filter.insurer === '' &&
            this.state.filter.user_role !== ''
          ) {
            return (
              users.user_profile.insurer_admin_role ===
              this.state.filter.user_role
            );
          }
          if (this.state.filter.user_role !== '') {
            if (this.state.filter.insurer !== '') {
              return (
                users.user_profile.insurer_admin_role ===
                  this.state.filter.user_role &&
                users.user_profile.company === this.state.filter.insurer
              );
            }
          }
          if (
            this.state.filter.insurer === '' &&
            this.state.filter.user_role === ''
          ) {
            return users;
          }
        });
        //console.log(this.state.filter);
        if (filtered.length > 0) {
          this.setState({ newUserList: filtered });
        } else {
          this.setState({ newUserList: [] });
        }
      }
    );
  };

  onChange = e => {
    //e.preventDefault();

    const { user } = this.state;
    const { name, value } = e.target;

    this.setState({
      user: {
        ...user,
        [name]: value
      }
    });
  };

  createUser = e => {
    e.preventDefault();
    const { user } = this.state;

    if (this.validator.allValid()) {
      this.validator.hideMessages();
      let newUser = {
        user: {
          first_name: user.first_name,
          last_name: user.last_name,
          other_names: user.other_names,
          email: user.email,
          username: user.username,
          phone: user.phone,
          postal_address: user.postal_address,
          is_active: 'True'
        },
        profile: {
          employee_number: user.employee_number
        },
        type: user.user_type
      };

      this.props.saveUser(newUser).then(() => {
        this.getFilteredUsers();
      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    const menuItems = [
      { id: 'all-users', name: 'All Users', active: true },
      { id: 'add-user', name: 'Add User' }
    ];

    const { filteredUsers } = this.state || {};
    let { isRegistering } = this.state;
    let { user, insurers } = this.props;

    const user_roles = [
      { key: 'insurer_admin', text: 'Insurer Admin', value: 'insurer_admin' },
      { key: 'sinbad_admin', text: 'Sinbad Admin', value: 'sinbad_admin' },
      { key: 'insurer_agent', text: 'Insurer Agent', value: 'insurer_agent' },
      { key: 'tax_collector', text: 'Tax Collector', value: 'tax_collector' },
      {
        key: 'insurer_association',
        text: 'Insurer Association',
        value: 'insurer_association'
      },
      {
        key: 'port_authority',
        text: 'Port Authority',
        value: 'port_authority'
      },
      {
        key: 'broker_association',
        text: 'Broker Association',
        value: 'broker_association'
      },
      {
        key: 'intermediary_admin',
        text: 'Intermediary Admin',
        value: 'intermediary_admin'
      },
      {
        key: 'insurer_regulator',
        text: 'Insurer  Regulator',
        value: 'insurer_regulator'
      },
      {
        key: 'corporate_admin',
        text: 'Corporate Admin',
        value: 'corporate_admin'
      },
      {
        key: 'port_authority',
        text: 'Port Authority',
        value: 'port_authority'
      },
      {
        key: 'clearing_agent',
        text: 'Clearing Agent',
        value: 'clearing_agent'
      },
      { key: 'sailor', text: 'Sailor', value: 'sailor' }
    ];

    console.log(this.state);
    return (
      <Page isAdminPage={true} pageTitle="Users">
        <div className="clearfix">
          <TabHolder menuItems={menuItems}>
            <Tab menuId={menuItems[0].id} isActive={true}>
              <div
                className="clearfix form form-inline"
                style={{ marginBottom: '2em' }}
              >
                <select
                  className="form-control"
                  name="user_role"
                  onChange={this.onChange2}
                >
                  <option value="">All Roles</option>
                  {user_roles.map((user_role, index) => {
                    return (
                      <option key={index} value={user_role.value}>
                        {user_role.text}
                      </option>
                    );
                  })}
                </select>
                <select
                  className="form-control"
                  name="insurer"
                  onChange={this.onChange2}
                >
                  >
                  <option value="">All Companies</option>
                  {insurers &&
                    insurers.insurers.map((insurer, index) => {
                      return (
                        <option key={index} value={insurer.id}>
                          {insurer.company_name}
                        </option>
                      );
                    })}
                </select>
              </div>
              {user.filteredUsers.length > 0 ? (
                <DataTable
                  tableId="users-table"
                  columnTitles={[
                    'Name',
                    'Email',
                    'Phone Number',
                    'Company Name'
                  ]}
                >
                  {user.filteredUsers.map((filteredUser, index) => {
                    return (
                      <tr key={index}>
                        <td>{filteredUser.first_name}</td>
                        <td>{filteredUser.email}</td>
                        <td>{filteredUser.phone}</td>
                        <td>{filteredUser.user_profile.company_name || ''}</td>
                      </tr>
                    );
                  })}
                </DataTable>
              ) : (
                <BlankState
                  data={user.filteredUsers}
                  dataName="Users"
                  isDataLoading={user.user_loading}
                />
              )}
            </Tab>

            <Tab menuId={menuItems[1].id}>
              <BlankState
                data={false}
                customMessage="Registering user..."
                isDataLoading={isRegistering}
              />
              <div className="col-md-6">
                <form
                  className="form-horizontal"
                  noValidate
                  onSubmit={this.createUser}
                >
                  {user.success ? (
                    <StatusMessages
                      type="success"
                      message={user.user_created.Info}
                    />
                  ) : null}
                  {user.errorCreateUser ? (
                    <StatusMessages
                      type="error"
                      message={user.errorMessageCreateUser}
                    />
                  ) : null}

                  <div className="form-group">
                    <label className="control-label col-md-4">
                      First Name: <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-8">
                      <input
                        type="text"
                        id="first_name"
                        onChange={this.onChange}
                        className="form-control"
                        name="first_name"
                        required
                      />
                      {this.validator.message(
                        'first_name',
                        this.state.user.first_name,
                        'required',
                        'text-danger'
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="control-label col-md-4">
                      Last Name: <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-8">
                      <input
                        type="text"
                        onChange={this.onChange}
                        className="form-control"
                        name="last_name"
                        id="last_name"
                        required
                      />
                      {this.validator.message(
                        'last_name',
                        this.state.user.last_name,
                        'required',
                        'text-danger'
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="control-label col-md-4">
                      Other Names:
                    </label>
                    <div className="col-md-8">
                      <input
                        type="text"
                        onChange={this.onChange}
                        className="form-control"
                        name="other_names"
                        id="other_names"
                      />
                      {this.validator.message(
                        'other_names',
                        this.state.user.other_names,
                        'required',
                        'text-danger'
                      )}
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="control-label col-md-4">
                      Phone Number: <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-8">
                      <input
                        type="text"
                        onChange={this.onChange}
                        className="form-control"
                        name="phone"
                        id="phone"
                      />
                      {this.validator.message(
                        'phone',
                        this.state.user.phone,
                        'required',
                        'text-danger'
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="control-label col-md-4">
                      Employee Number: <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-8">
                      <input
                        type="text"
                        onChange={this.onChange}
                        className="form-control"
                        name="employee_number"
                        id="employee_number"
                      />
                      {this.validator.message(
                        'employee_number',
                        this.state.user.employee_number,
                        'required',
                        'text-danger'
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="control-label col-md-4">
                      Postal Address:{' '}
                    </label>
                    <div className="col-md-8">
                      <input
                        type="text"
                        onChange={this.onChange}
                        className="form-control"
                        name="postal_address"
                        id="postal_address"
                      />
                      {this.validator.message(
                        'postal_address',
                        this.state.user.postal_address,
                        'required',
                        'text-danger'
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="control-label col-md-4">
                      User Type: <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-8">
                      <select
                        className="form-control"
                        name="user_type"
                        id="user_type"
                        onChange={this.onChange}
                      >
                        <option value="" disabled>
                          {' '}
                          -- Select User Type --{' '}
                        </option>
                        <option value="broker_association_admin">
                          TIBA Administrator
                        </option>
                        <option value="tax_agency_admin">
                          TRA Administrator
                        </option>
                        <option value="port_authority">TPA Admin</option>
                        <option value="insurer_regulator">TIRA Admin</option>
                        <option value="insurer_association_admin">
                          IIT Admin
                        </option>
                      </select>
                      {this.validator.message(
                        'user_type',
                        this.state.user.user_type,
                        'required',
                        'text-danger'
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="control-label col-md-4">
                      Username: <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-8">
                      <input
                        type="text"
                        onChange={this.onChange}
                        className="form-control"
                        name="username"
                        id="username"
                      />
                      {this.validator.message(
                        'username',
                        this.state.user.username,
                        'required',
                        'text-danger'
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="control-label col-md-4">
                      Email: <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-8">
                      <input
                        type="text"
                        onChange={this.onChange}
                        className="form-control"
                        name="email"
                        id="email"
                      />
                      {this.validator.message(
                        'email',
                        this.state.user.email,
                        'required',
                        'text-danger'
                      )}
                    </div>
                  </div>
                  <div className="col-md-8 col-md-offset-4">
                    <button
                      type="submit"
                      id="createUserBtn"
                      className="btn btn-primary"
                    >
                      <i className="icon ion-checkmark" /> Create User
                    </button>
                  </div>
                </form>
              </div>
            </Tab>
          </TabHolder>
        </div>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  insurers: state.insurers
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { saveUser, fetchFilteredUsers, listInsurers },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Users);



// WEBPACK FOOTER //
// ./src/pages/dashboard/Users.jsx